export default "/assets/images/peacekeeper-2.png?804be3c9ebcccc317b7f8bd5700cad5d";